import { createReducer } from 'redux-act'
import u from 'updeep'

import { switchLocale, toggleHowItWorks } from 'actions/ui'

const initialState = {
  locale: '',
  howItWorksOpened: false,
}

export default createReducer({
  [switchLocale]: (state, { locale }) => u({ locale }, state),
  [toggleHowItWorks]: (state) => u({ howItWorksOpened: !state.howItWorksOpened }, state),
}, initialState)
